// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { RedocStandalone } from 'redoc';
import { DocumentationContainer } from 'common/containers/documentation/Styles';
import { Loader } from 'common/components';
import {
    documentation,
    IDocumentationResponse,
} from 'common/api/resources/Documentation';
import { rewriteCodeSampleUrl } from 'common/helpers/documentation';
import { track } from 'common/analytics/mixpanel';
import { ANALYTICS_EVENTS } from 'common/analytics/constants';

const Documentation: React.FC = () => {

    React.useEffect(() => {
        track(ANALYTICS_EVENTS.ADMIN.DOCUMENTATION.VISIT);
    }, []);

    const [json, setJson] = React.useState<IDocumentationResponse>();

    React.useEffect(() => {
        const fetch = async () => {
            const result = await documentation.get();

            for (const path of Object.keys(result.data.paths)) {
                for (const method of Object.keys(result.data.paths[path])) {
                    const sample = result.data.paths[path][method]['x-code-samples'];
                    sample[0].source = rewriteCodeSampleUrl(sample[0].source, process.env.REACT_APP_API_URL);
                }
            }

            setJson(result.data);
        };

        fetch();
    }, []);

    return (
        <Loader isLoading={json === undefined}>
            <DocumentationContainer>
                <RedocStandalone
                    spec={json}
                    options={{
                        theme: { colors: { primary: { main: '#dd5522' } } },
                    }}
                />
            </DocumentationContainer>
        </Loader>
    );
};

export default Documentation;